import { useEffect, useState } from 'react';
import { getDataWithToken } from 'Utils/api';
import { getUser } from 'Utils/storage';

const LEGEND_URL = '/api/0.1/tracking/legend';

/**
 * Fetches the tracking legend (colors/status meanings for routes, trucks,
 * GPS pings and route waypoints) and keeps the categories separate, matching
 * how the consumers of this data (map + status badges) will need to use them.
 */
export const useLegend = () => {
  const [routeLegend, setRouteLegend] = useState([]);
  const [truckLegend, setTruckLegend] = useState([]);
  const [pingLegend, setPingLegend] = useState([]);
  const [routePointLegend, setRoutePointLegend] = useState([]);

  useEffect(() => {
    getDataWithToken(LEGEND_URL, { company_id: getUser().company_id })
      .then((response) => {
        const legend = (response && response.data) || {};
        console.log('[TripTrackingV2] legend stored:', legend);
        setRouteLegend(legend.route_legend || []);
        setTruckLegend(legend.truck_legend || []);
        setPingLegend(legend.ping_legend || []);
        setRoutePointLegend(legend.route_point_legend || []);
      })
      .catch((error) => console.log('[TripTrackingV2] legend error:', error));
  }, []);

  return { routeLegend, truckLegend, pingLegend, routePointLegend };
};
